module.exports = __webpack_public_path__ + "static/media/starOff_326.fca49d20.png";